import { Box, Heading, HStack, Pressable, Radio, VStack } from 'native-base';
import React, { ReactNode } from 'react';

import { tID } from 'app/services/TestHelper';

export type RadioButtonCardProps = {
  isSelected: boolean;
  value: string;
  title: string;
  children?: ReactNode;
  onPress: () => void;
  testID?: string;
};

export default function RadioButtonCard({
  isSelected,
  value,
  title,
  children,
  onPress,
  testID,
}: RadioButtonCardProps) {
  return (
    <Pressable testID={tID(testID || 'RadioButtonCard')} w="full" onPress={onPress}>
      <HStack
        borderColor={isSelected ? 'brand.active' : 'gray.300'}
        borderWidth="2"
        p="3"
        rounded="md"
        space="3"
      >
        <Radio aria-label={title || value} value={value} onTouchEnd={onPress} />
        <VStack flex="1" space="2">
          <Heading mt="3px" size="sm">
            {title}
          </Heading>
          {children && <Box>{children}</Box>}
        </VStack>
      </HStack>
    </Pressable>
  );
}
